/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export class Color {
  red: number;
  green: number;
  blue: number;
}
